import React from 'react'

const FormTextArea = ({ input, label, type, placeholder, direction, loading, meta: { touched, error, warning } }) => {
  if (direction === 'vertical') {
    return (
      <div className={(touched && error) ? 'has-error' : ''}>
        <label className='control-label'>{label}</label>
        <textarea cols='3' className='form-control' {...input} placeholder={placeholder} disabled={loading} />
        {touched && (error && <span className='help-block'>{error}</span>)}
      </div>
    )
  } else {
    return (
      <div className={(touched && error) ? 'has-error' : ''}>
        <label className='col-sm-2 control-label'>{label}</label>
        <div className='col-sm-9'>
          <textarea cols='3' className='form-control' {...input} placeholder={placeholder} disabled={loading} />
          {touched && (error && <span className='help-block'>{error}</span>)}
        </div>
      </div>
    )
  }
}

export default FormTextArea



// WEBPACK FOOTER //
// ./src/components/FormTextarea.js